import { render } from "./JFpurchase.vue?vue&type=template&id=f8038ba6&scoped=true"
import script from "./JFpurchase.vue?vue&type=script&lang=js"
export * from "./JFpurchase.vue?vue&type=script&lang=js"

import "./JFpurchase.vue?vue&type=style&index=0&id=f8038ba6&lang=scss&scoped=true"
import "./JFpurchase.vue?vue&type=style&index=1&id=f8038ba6&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8038ba6"]])

export default __exports__